import { Box, SxProps, Theme } from "@mui/material";

interface ImageViewDetails {
  src?: string | null;
  width: string | number;
  height: string | number;
  scale?: string;
  props?: SxProps<Theme>;
  onLoaded?: () => void;
}

export const CustomImageView: React.FC<ImageViewDetails> = ({
  src,
  width,
  height,
  scale = "cover",
  props,
  onLoaded,
}: ImageViewDetails) => {
  return src ? (
    <Box
      component="img"
      src={src ?? ""}
      onLoad={onLoaded}
      sx={[
        {
          width: width,
          height: height,
          objectFit: scale,
        },
        ...(Array.isArray(props) ? props : [props]),
        ,
      ]}
    />
  ) : (
    <></>
  );
};
